// extracted by mini-css-extract-plugin
export default {"container":"Question_container__nJDkn"};